import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TicketService } from '../../../../../../common/services/Ticket.service';
import { ContactService } from '../../../../../../common/services/Contact.service';
import { UserService } from '../../../../../../common/services/User.service';
import { SearchService } from '../../../../../../common/services/Search.service';
import { TicketsConst } from './tickets.const';
import { Observable } from 'rxjs';
import { AgentModalType } from '../../../../../../components/modals/agent-modal/agent-modal.const';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { DefaultField } from '../../../setting/contact/properties/properties.const';

@Component({
  selector: 'detail-organize-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css', '../../../../../../../css/fuck.css', '../../../search/search.css'],
  providers: [TicketService, ContactService, UserService, SearchService],
})
export class TicketsComponent extends BaseListComponent {
  @ViewChild('agentTemplate') agentTemplate: ElementRef;
  @ViewChild('statusTemplate') statusTemplate: ElementRef;

  @Input() organize_id: any = null;
  @Output() onOpenTicket: EventEmitter<any> = new EventEmitter();
  public lstAgents: any = [];
  public lstContacts: any = [];
  public allStatus: any = [];
  public allAgents: any = [];
  public allContacts: any = [];
  public allSources = [
    { id: '', text: 'Nguồn khởi tạo' },
    { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
    { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
    { id: 'chat', text: 'Tin nhắn web' },
    { id: 'hand', text: 'Thêm mới' },
    { id: 'zalo', text: 'Zalo' },
    { id: 'email', text: 'Email' },
    { id: 'facebook', text: 'Kênh Facebook' },
  ];
  public modelFilter: any = {
    status: '',
    source_detail: '',
    assign_agent_id: '',
    requester_id: '',
  };
  public modalAgentType = AgentModalType.AGENT_TO_TRANSPORT;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private ticketService: TicketService,
    private contactService: ContactService,
    private userService: UserService,
    private searchService: SearchService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = TicketsConst.displayColumns();
  }

  async ngOnInit() {
    Observable.forkJoin([this.loadUsers(), this.loadContacts(), this.getStatus()]).subscribe(res => {
      this.lstAgents = res[0];
      if (this.lstAgents && this.lstAgents.length > 0) {
        const agents =
          this.lstAgents.map(a => {
            return {
              text: a.name,
              id: a._id,
            };
          }) || [];
        this.allAgents = [{ id: '', text: 'Chuyên viên' }, ...agents];
        this.allContacts = [{ id: '', text: 'Người yêu cầu' }, ...agents];
      }
      this.lstContacts = res[1];
      if (this.lstContacts && this.lstContacts.length > 0) {
        const contacts = this.lstContacts.map(a => {
          return {
            text: a.name,
            id: a._id,
          };
        });
        this.allContacts = [...this.allContacts, ...contacts];
      }
      this.loadData();
    });
  }

  getStatus() {
    return this.ticketService.status().map(res => {
      const statusList = [];
      res.data.forEach((c: any) => {
        statusList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allStatus = statusList;
    });
  }

  loadUsers() {
    const whereUser = {
      filters: JSON.stringify([
        {
          key: 'organize_id',
          condition: '=',
          value: this.organize_id,
        },
      ]),
    };
    return this.userService
      .list(whereUser)
      .toPromise()
      .then(res => res.data.list);
  }

  loadContacts() {
    const condition = {
      must: [{ term: { organize_id: this.organize_id } }],
    };
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(['organize_id']),
      type: 'user',
      label: 'and',
      sub_label: 'and',
      keyword: '',
      force_search: 'customer',
      limit: 10000,
      offset: 0,
    };
    return this.searchService
      .all(body)
      .toPromise()
      .then(res => res.data.list);
  }

  async loadData(request: any = {}, sort?: any) {
    const params = {
      source: 'all',
      limit: this.page_size,
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      sort_by: 'updated_at:desc',
    };
    const users = [...this.lstAgents, ...this.lstContacts];
    const userIds = users.map(user => user._id.toString());
    const must: any = [{ terms: { requester_id: userIds } }];
    if (this.modelFilter.status) {
      must.push({ term: { status: this.modelFilter.status } });
    }
    if (this.modelFilter.source_detail) {
      must.push({ match: { source_detail: this.modelFilter.source_detail } });
    }
    if (this.modelFilter.assign_agent_id) {
      must.push({
        match: { assign_agent_id: this.modelFilter.assign_agent_id },
      });
    }
    if (this.modelFilter.requester_id) {
      must.push({ match: { requester_id: this.modelFilter.requester_id } });
    }
    const condition: any = {
      must: [
        {
          bool: {
            must: must,
          },
        },
      ],
    };
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(['assign_agent_id', 'requester_id']),
      type: 'ticket',
      label: 'and',
      sub_label: 'and',
      keyword: '',
      force_search: 'customer',
      limit: this.page_size,
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
    };
    this.searchService.list(params, body).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.res.list;
        this.data = this.data.map(e => {
          e.display_code = TicketsConst.displayCodeColumns(e);
          e.display_requester = TicketsConst.displayRequesterColumns(e.request, this.user);
          e.display_subject = TicketsConst.displaySubjectColumns(e, this.user);
          e.display_assignee = TicketsConst.displayAssigneeColumns(e, this.lstAgents);
          e.display_source = TicketsConst.displaySourceColumns(e);
          e.display_status = TicketsConst.displayStatusColumns(e);
          e.display_created_at = TicketsConst.displayTimeColumns(e.created_at);
          e.display_updated_at = TicketsConst.displayTimeColumns(e.updated_at);
          return e;
        });
        this.initPage(res.data.res.total);
      } else {
        this.data = [];
      }
    });
  }

  async changeFilter(key, $event) {
    let value = $event.target.value;
    if (value === '-1') {
      value = '';
    }
    this.modelFilter[key] = value;
    await this.loadData();
  }

  async changeSelect2Filter(key, $event) {
    let value = $event.value;
    if (value === '-1' || value === 'Chuyên viên' || value === 'Người yêu cầu') {
      value = '';
    }
    this.modelFilter[key] = value;
    await this.loadData();
  }

  async resetModelFilter() {
    this.modelFilter = {
      status: '',
      source_detail: '',
      assign_agent_id: '',
      requester_id: '',
    };
    await this.loadData();
  }

  async openTicket(ticket: any) {
    this.onOpenTicket.emit({ data: ticket });
  }

  async submitFastStatus(status) {
    const ids = this.lstChecked;
    this.ticketService.updateMany({ _id: { $in: ids } }, { status: status }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật trạng thái thành công!');
          this.lstChecked = [];
          this.closeModal();
          this.data = this.data.map(e => {
            if (ids.includes(e._id.toString())) {
              e.status = status;
              e.display_status = TicketsConst.displayStatusColumns(e);
            }
            return e;
          });
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
  async submitMergeTickets(id) {
    const ticketMerges = this.lstChecked.filter(check => check !== id);
    this.ticketService.merges({ ticket_id: id, merge_ticket_ids: ticketMerges }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.throwSuccess('Hợp nhất ticket thành công!');
        this.closeModal();
        this.is_loading = true;
        setTimeout(() => {
          this.loadData();
          this.is_loading = false;
        }, 3000);
      } else {
        this.message = {
          class: 'alert dark alert-danger',
          content: res.message,
        };
      }
    });
  }

  async openAgentModal() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modelContent.title = 'Chuyển nhanh cho chuyên viên';
    this.openModal(this.agentTemplate, config);
  }

  async openStatusModal() {
    this.typeModal = 'changeStatus';
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Chuyển nhanh trạng thái',
      submit_title: 'Chuyển',
    };
    this.modelDisplay = [
      {
        key: 'fast_status',
        label: 'Trạng thái',
        type: FormFieldType.Select,
        value: this.model.fast_status,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: {
          data: this.allStatus,
          select2Options: {
            placeholder: { id: '', text: 'Trạng thái' },
          },
        },
      },
    ];
    this.openModal(this.statusTemplate, config);
  }
  async openMergeTicket() {
    this.typeModal = 'mergeTicket';
    let ticketToMerge = this.data.filter(data => this.lstChecked.includes(data._id)) || [];
    const checkTicket = [];
    for (let i = 0; i < ticketToMerge.length; i++) {
      if (ticketToMerge[i].requester_id && !checkTicket.includes(ticketToMerge[i].requester_id)) {
        checkTicket.push(ticketToMerge[i].requester_id);
      }
    }
    if (checkTicket.length > 1) {
      return this.throwError('Bạn chỉ có thể hợp nhất những ticket có cùng một người yêu cầu!');
    }
    ticketToMerge = ticketToMerge.map(data => {
      return { id: data._id, text: `${data.subject} | mã: ${data.code}` };
    });
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Hợp nhất nhanh ticket',
      submit_title: 'Hợp nhất',
    };
    this.modelDisplay = [
      {
        key: 'main_id',
        label: 'Chọn ticket chính',
        type: FormFieldType.Select2,
        value: this.model.main_id,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: {
          data: [{ id: '', text: 'Chọn' }, ...ticketToMerge],
          select2Options: {
            placeholder: { id: '', text: 'Ticket chính' },
          },
        },
      },
      {
        key: '_note',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted text-sm mt-1">Vui lòng chọn ticket chính trong danh sách ticket bạn đã chọn. Tất cả các ticket khác sẽ được hợp nhất vào ticket này!</span>`,
        width: 'full',
        order: 1,
      },
    ];
    this.openModal(this.statusTemplate, config);
  }

  async handleTransportAgent(item: any) {
    const payload = {
      assign_agent_id: item._id,
      assign_group_id: item.group_id || null,
    };
    const update_ids = this.lstChecked;
    this.ticketService.updateMany({ _id: { $in: update_ids } }, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Chuyển chuyên viên xử lý thành công!');
          this.lstChecked = [];
          this.closeModal();
          this.data = this.data.map(e => {
            if (update_ids.includes(e._id.toString())) {
              e.assign_agent_id = item._id;
              e.assign_group_id = item.group_id || null;
              e.display_assignee = TicketsConst.displayAssigneeColumns(e, this.lstAgents);
            }
            return e;
          });
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async handleSubmit(item?: any) {
    if (this.typeModal === 'changeStatus') {
      await this.submitFastStatus(item.fast_status);
    } else if (this.typeModal === 'mergeTicket') {
      await this.submitMergeTickets(item.main_id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/organize/tickets/tickets.component.ts